import { LoggerService } from "@modules/common/logger/loggerService"
import { ApiClient } from "@modules/core/api/client/apiClient"
import { type ProgramSubscriptionDto, ProgramSubscriptionDtoSchema } from "@modules/programs/gateway/programDto"
import { type ProgramInfiniteApiGateway } from "@modules/programs/gateway/programInfiniteApiGateway"
import {
  type StripeProgramSubscriptionDto,
  StripeProgramSubscriptionDtoSchema,
} from "@modules/programs/gateway/programInfiniteDto"

export class ProgramInfiniteApi implements ProgramInfiniteApiGateway {
  private baseUrl = "/programs"

  constructor(private api: ApiClient) {}

  async getProgramInfiniteStripeSubscriptionInfos(programId: string) {
    const resultDto = await this.api.get<StripeProgramSubscriptionDto | null>(
      `${this.baseUrl}/${programId}/subscription`,
    )
    return resultDto.data ? LoggerService.parseApiDto(StripeProgramSubscriptionDtoSchema, resultDto.data) : null
  }

  async subscribeProgramInfinite(programId: string) {
    const result = await this.api.post<ProgramSubscriptionDto>(`${this.baseUrl}/${programId}/subscribe`)
    return LoggerService.parseApiDto(ProgramSubscriptionDtoSchema, result.data)
  }

  async unsubscribeProgramInfinite(programId: string) {
    const result = await this.api.post<ProgramSubscriptionDto>(`${this.baseUrl}/${programId}/unsubscribe`)
    return LoggerService.parseApiDto(ProgramSubscriptionDtoSchema, result.data)
  }
}
